import React from 'react';
import { AIcon } from '../../atoms/AIcon/index';
import { AImage } from '../../atoms/AImage/index';
import { ASubheader } from '../../atoms/ASubheader/index';
import { ASubheaderSize } from '../../atoms/ASubheader/ASubheader.types';
import { HeaderRow, HeaderRowImage, HeaderRowText } from './MAccordionControl.styles';
import { type MAccordionControlProps, MAccordionControlType } from './MAccordionControl.types';
import { ABody } from '../../atoms/ABody';
import type { AImageProps } from '../../atoms/AImage/AImage.types';
import { type AIconProps, AIconSize } from '../../atoms/AIcon/AIcon.types';
import { type ABodyProps, ABodySize } from '../../atoms/ABody/ABody.types';
import type { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import clsx from 'clsx';
import { AspectRatio, MediaQuery, ResponsiveImageSpec, generateImageRenditions } from '../../utils/ImageUtils';

const IMG_WIDTH_PX = 100;
const RESPONSIVE_IMAGE_SPECS: ResponsiveImageSpec[] = [
  {
    media: MediaQuery.MIN_WIDTH_XS,
    aspectRatio: AspectRatio.STANDARD_HOR,
    imgWidthPx: IMG_WIDTH_PX,
  },
];

const COMPONENT_NAME = 'm-web-ui-kit-MAccordionControl';
const TEST_ID = 'web-ui-kit-MAccordionControl';

function MAccordionControl({
  type = MAccordionControlType.Icon,
  aImage = {},
  aIcon = {},
  aSubheader = {},
  aBody = {},
  icon,
  custom_click_track_value,
  ...rest
}: MAccordionControlProps, ref: React.Ref<HTMLButtonElement>) {
  const _aSubheader = {
    ...aSubheader,
    size: aSubheader.size || ASubheaderSize.L,
    className: clsx(aSubheader.className, 'm-ellipsis-2'),
  };
  const _aBody = {
    ...aBody,
    size: aBody.size || ABodySize.XS,
    className: clsx(aBody.className, 'm-ellipsis-1'),
  };
  const _aIcon = {
    ...aIcon,
    size: aIcon.size || AIconSize.L,
    className: clsx(aIcon.className, 'a-icon-branded'),
  };
  const _aImage = {
    ...aImage,
    imgClass: clsx(aImage.imgClass, 'm-accordion-control-image'),
    renditions: generateImageRenditions(RESPONSIVE_IMAGE_SPECS, aImage.src),
  };
  return (
    <HeaderRow data-component-name={COMPONENT_NAME} data-testid={TEST_ID} ref={ref} {...rest}>
      {type === MAccordionControlType.Image && _aImage.src && (
        <HeaderRowImage $widthPx={IMG_WIDTH_PX}>
          <AImage {...(_aImage as AImageProps)} />
        </HeaderRowImage>
      )}
      {type === MAccordionControlType.Icon && _aIcon.icon && <AIcon {...(_aIcon as AIconProps)} />}
      <HeaderRowText>
        {_aSubheader.text && <ASubheader {...(_aSubheader as ASubheaderProps)} />}
        {_aBody.bodyText && <ABody {...(_aBody as ABodyProps)} />}
      </HeaderRowText>
      {icon && <AIcon aria-hidden="true" icon={icon} size={AIconSize.L} />}
    </HeaderRow>
  );
}

const MAccordionControlWithRef = React.forwardRef(MAccordionControl);

export { MAccordionControlWithRef as MAccordionControl, MAccordionControlType, TEST_ID as M_ACCORDION_CONTROL_TEST_ID };
